---
fr:
  errors:
    messages:
      after: doit être après %{restriction}
      before: doit être avant %{restriction}
      invalid_date: n'est pas une date valide
      invalid_datetime: n'est pas une date/heure valide
      invalid_time: n'est pas une heure valide
      is_at: doit être à %{restriction}
      on_or_after: doit être le ou après %{restriction}
      on_or_before: doit être le ou avant %{restriction}
